export const fontOverrides = {
  fonts: {
    serif: 'UniversNextforHSBCW02, Arial, sans-serif',
  },
};
